import createDataContext from './createDataContext';
import * as blogActions from './actions/blogEntryActions';
import { blogEntryReducer, initialState } from './reducers/blogEntryReducer';

export const { Context: BlogEntryContext, Provider } = createDataContext(
  blogEntryReducer,
  blogActions,
  initialState
);
